import CreateByteArrayFromURL from "../../utils/CreateByteArrayFromURL";
import * as Constants from "../../consts/Constants.js";
import { isEmptyString } from "../../utils/StringUtils.js";

export default {
  parseToServer: (newAlert) => {
    let auth = JSON.parse(localStorage.getItem("auth"));
    let objectServer = {
      title: newAlert.title,
      body: newAlert.body,
      categoryId:
        newAlert.subcategory !== -1 ? newAlert.subcategory : newAlert.category,
      url: !isEmptyString(newAlert.link) ? newAlert.link : null,
      alert: newAlert.alert,
      serviceId: Constants.SERVICE_NOTICE_ID,
      state: 0,
      userId: auth.userId,
      binData:
        newAlert.image !== null
          ? CreateByteArrayFromURL(newAlert.image.image)
          : null,
      binType: newAlert.image !== null ? newAlert.image.type : null,
    };
    return objectServer;
  },
};
